// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"78145b50","453":"63834957"}[chunkId] + ".chunk.js";
};